import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import IndexRoute from 'react-router/lib/IndexRoute';
import Route from 'react-router/lib/Route';
import { useFeatureFlags } from '../../infra/feature-flags';
import { RouterBridge } from '../../infra/routing';
import { ClientReferralsProgram } from './client-referrals-program';
var ClientReferralsRoutesChecker = function (_a) {
    var children = _a.children;
    var clientReferrals = useFeatureFlags().clientReferrals;
    if (!clientReferrals) {
        RouterBridge.push('/');
        return null;
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
};
export var ClientReferralsRoutes = function () { return (_jsx(Route, { path: "/client-referrals", component: ClientReferralsRoutesChecker, children: _jsx(IndexRoute, { component: ClientReferralsProgram }) })); };
